
// CurrencyField.js

import React, { useRef } from 'react';
import { NumericFormat } from 'react-number-format';

function CurrencyField({ value, onChange }) {
  const inputRef = useRef(null);

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(0, 0);
    }
  };

  return (
    <NumericFormat
      getInputRef={inputRef}
      value={value}
      onValueChange={(values) => {
        const { floatValue } = values;
        onChange(floatValue);
      }}
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale
      placeholder="Digite o valor"
      style={{ width: '120px', height: '30px', marginBottom: '0px', textAlign: 'left' }}
      onFocus={handleFocus}
    />
  );
}

export default CurrencyField;